export function getEmailContent(type, data) {
    if (type === 'orgMemberInvite') {
        return {
            "to": [{"email": data.email}],
            "templateId": 5,
            "params": {
                "orgIconUrl": data.orgIcon,
                "orgName": data.orgName,
                "managerName": data.managerName,
                "buttonText": "Get Started",
                "buttonLink": "https://gamably.com",
            },
            
        };
    }
    if (type === 'gameManagerInvite') {
        return {
            "to": [{"email": data.email}],
            "templateId": 6,
            "params": {
                "gameIcon": data.gameIcon,
                "gameName": data.gameName,
                "managerName": data.managerName,
                "userName": data.userName,
                "fName": data.fName,
                "lName": data.lName,
                "role": data.role,
                "roleDesc": data.role === 'manager' 
                ? 'manage players and teams, create and edit game elements, distribute rewards, and more' 
                : 'view players, and distribute rewards',
                "buttonText": "Get Started",
                "buttonLink": "https://gamably.com",
                "appId": data.appId,
                "inviteAppId": data.inviteAppId,
            }
        };
    }
}